import { Navigate } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MY_CARDS_GALLERY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const GalleryPage = () => {
  const { currentUser } = useCurrentUserContext();
  const { generateSportContextPath } = useSportContext();
  const rarity = currentUser?.anyUserSportProfile?.proUnlocked
    ? Rarity.limited
    : Rarity.common;

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_GALLERY_RARITY, {
        params: {
          rarity,
        },
      })}
      replace
    />
  );
};

export default GalleryPage;
